module.exports = __webpack_public_path__ + "img/08.b596457f.jpg";